import type { MessageChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import {
  emailIntegrationMissingRule,
  emailIntegrationRevokedRule,
} from "./rules/email";
import { metaSevenDayRule } from "./rules/meta-dm";
import type { BlockRule } from "./types";

/**
 * Per-channel send-blocking rules. The first matching rule wins — order
 * matters.
 *
 * To add a new reason:
 *   1. Write a pure `BlockRule` under `./rules/`.
 *   2. Append it to every channel it should run on below.
 *
 * To add a new channel: add a new key with its ordered rule list. Channels
 * that are not in this registry are never blocked by this pipeline (the send
 * path is still the source of truth server-side).
 */
export const BLOCK_RULES_BY_CHANNEL: Partial<
  Record<MessageChannel, readonly BlockRule[]>
> = {
  gmail: [emailIntegrationMissingRule, emailIntegrationRevokedRule],
  outlook: [emailIntegrationMissingRule, emailIntegrationRevokedRule],
  facebookDm: [metaSevenDayRule],
  instagramDm: [metaSevenDayRule],
};
